import { ReactNode } from "react";
import { Link } from "react-router-dom";

type ActionButtonProps = {
  children: ReactNode;
  to?: string;
  onClick?: () => void;
  variant?: "primary" | "ghost";
  disabled?: boolean;
};

export function ActionButton({
  children,
  to,
  onClick,
  variant = "primary",
  disabled = false
}: ActionButtonProps) {
  const className = `action-button ${variant} ${disabled ? "disabled" : ""}`;

  if (to && !disabled) {
    return (
      <Link className={className} to={to}>
        {children}
      </Link>
    );
  }

  return (
    <button className={className} type="button" disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
}
